export const SL_MANAGEMENT_CREATE_LIST = "si.management.sl.createList.btn.text";
